(function() {
    'use strict';

    let hiddenSections = [];
    let buttonMoved = false;
    let originalButtonParent = null;
    let originalButtonNextSibling = null;

    function hideContentSections() {
        const allSections = document.querySelectorAll("main > .shopify-section");
        const readMoreSection = Array.from(allSections).find(section => 
        section.querySelector('[data-read-more]')
        );
        
        if (!readMoreSection) return;
        
        const readMoreIndex = Array.from(allSections).indexOf(readMoreSection);
        
        // Clear hiddenSections array
        hiddenSections = [];
        
        // Hide all sections after the read-more section, except wrap-from-medium
        for (let i = readMoreIndex + 1; i < allSections.length; i++) {
        const section = allSections[i];
        if (!hasWrapFromMedium(section)) {
            // Add transition before hiding
            section.style.transition = 'opacity 0.3s ease-in-out, transform 0.3s ease-in-out';
            section.style.opacity = '0';
            section.style.transform = 'translateY(-10px)';
            
            setTimeout(() => {
            section.style.display = 'none';
            }, 300);
            
            hiddenSections.push(section);
        }
        }
    }

    function showContentSections() {
        hiddenSections.forEach(function(section, index) {
        section.style.display = '';
        section.style.opacity = '0';
        section.style.transform = 'translateY(10px)';
        
        // Stagger the animations slightly
        setTimeout(() => {
            section.style.opacity = '1';
            section.style.transform = 'translateY(0)';
        }, 50 + (index * 50));
        });
    }

    function moveButtonToEnd() {
        if (buttonMoved || hiddenSections.length === 0) return;
        
        const btn = document.querySelector('[data-read-more-btn]');
        if (!btn) return;
        
        // Store original parent and position
        originalButtonParent = btn.parentElement;
        originalButtonNextSibling = btn.nextElementSibling;
        
        // Find the last hidden section
        const lastHiddenSection = hiddenSections[hiddenSections.length - 1];
        
        // Add fade out transition to button
        btn.style.transition = 'opacity 0.2s ease-in-out';
        btn.style.opacity = '0';
        
        setTimeout(() => {
        // Create the wrapper structure
        const wrapDiv = document.createElement('div');
        wrapDiv.className = 'wrap';
        
        const gridDiv = document.createElement('div');
        gridDiv.className = 'grid grid--2-24';
        
        const gridItemDiv = document.createElement('div');
        gridItemDiv.className = 'grid__item grid__item--2 grid__item--medium grid__item--medium--24 grid__item--large--offset--1 grid__item--large--22';
        
        // Move button into the wrapper structure
        gridItemDiv.appendChild(btn);
        gridDiv.appendChild(gridItemDiv);
        wrapDiv.appendChild(gridDiv);
        
        // Add the wrapped button to the last section
        lastHiddenSection.appendChild(wrapDiv);
        
        // Fade button back in
        setTimeout(() => {
            btn.style.opacity = '1';
        }, 50);
        
        buttonMoved = true;
        }, 200);
    }

    function moveButtonToOriginal() {
        if (!buttonMoved || !originalButtonParent) return;
        
        const btn = document.querySelector('[data-read-more-btn]');
        if (!btn) return;
        
        // Add fade out transition
        btn.style.transition = 'opacity 0.2s ease-in-out';
        btn.style.opacity = '0';
        
        setTimeout(() => {
        // Remove the entire wrapper structure
        const wrapDiv = btn.closest('.wrap');
        if (wrapDiv) {
            wrapDiv.parentElement.removeChild(wrapDiv);
        }
        
        // Move button back to original position
        if (originalButtonNextSibling) {
            originalButtonParent.insertBefore(btn, originalButtonNextSibling);
        } else {
            originalButtonParent.appendChild(btn);
        }
        
        // Fade button back in
        setTimeout(() => {
            btn.style.opacity = '1';
        }, 50);
        
        buttonMoved = false;
        }, 200);
    }

    function hasWrapFromMedium(element) {
        return element.querySelector('.wrap-from-medium') !== null;
    }

    function initReadMore() {
        const readMoreComponents = document.querySelectorAll('[data-read-more]');
        
        readMoreComponents.forEach(function(component) {
        if (component.hasAttribute('data-initialized')) return;
        
        const btn = component.querySelector('[data-read-more-btn]');
        const preview = component.querySelector('.read-more-preview');
        const full = component.querySelector('.read-more-full');
        const readMoreText = component.querySelector('.read-more-text');
        const readLessText = component.querySelector('.read-less-text');
        
        if (!btn || !preview || !full) return;
        
        btn.addEventListener('click', function(event) {
            event.preventDefault();
            
            const isExpanded = full.style.display !== 'none';
            
            if (isExpanded) {
            // Collapse
            full.style.transition = 'opacity 0.3s ease-in-out';
            full.style.opacity = '0';
            
            setTimeout(() => {
                preview.style.display = 'block';
                full.style.display = 'none';
                readMoreText.style.display = 'inline';
                readLessText.style.display = 'none';
                
                preview.style.opacity = '0';
                preview.style.transition = 'opacity 0.3s ease-in-out';
                setTimeout(() => preview.style.opacity = '1', 50);
                
                hideContentSections();
                // Move button back to original position
                setTimeout(moveButtonToOriginal, 400);
            }, 300);
            
            } else {
            // Expand
            // Move button to end FIRST, before content transitions
            setTimeout(moveButtonToEnd, 100);
            
            preview.style.transition = 'opacity 0.3s ease-in-out';
            preview.style.opacity = '0';
            
            setTimeout(() => {
                preview.style.display = 'none';
                full.style.display = 'block';
                readMoreText.style.display = 'none';
                readLessText.style.display = 'inline';
                
                full.style.opacity = '0';
                full.style.transition = 'opacity 0.3s ease-in-out';
                setTimeout(() => full.style.opacity = '1', 50);
                
                showContentSections();
            }, 300);
            }
        });
        
        // Set initial state
        preview.style.display = 'block';
        full.style.display = 'none';
        readMoreText.style.display = 'inline';
        readLessText.style.display = 'none';
        
        component.setAttribute('data-initialized', 'true');
        });
        
        // Hide sections on page load
        hideContentSections();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
        if (typeof Shopify !== 'undefined') {
            initReadMore();
        }
        });
    } else {
        if (typeof Shopify !== 'undefined') {
        initReadMore();
        }
    }
})();